"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerBurnedBudgetHandle = void 0;
const CustomerBurnedBudgetRatio_1 = require("./CustomerBurnedBudgetRatio");
const CustomerBurnedBudgetCombinationKey_1 = require("./CustomerBurnedBudgetCombinationKey");
class CustomerBurnedBudgetHandle {
    constructor(burnedBudget) {
        Object.assign(this, burnedBudget);
    }
    getCombinationKeys() {
        return Object.keys(this.combinations).map((key) => (0, CustomerBurnedBudgetCombinationKey_1.deserializeCustomerBurnedBudgetCombinationKey)(key));
    }
    getCombination(key) {
        const str = (0, CustomerBurnedBudgetCombinationKey_1.serializeCustomerBurnedBudgetCombinationKey)(key);
        return this.combinations[str] || 0;
    }
    getTotal() {
        return this.budgeted + this.unbudgeted;
    }
    getRatio(budget, now) {
        return new CustomerBurnedBudgetRatio_1.CustomerBurnedBudgetRatio(budget, this.getTotal(), now);
    }
}
exports.CustomerBurnedBudgetHandle = CustomerBurnedBudgetHandle;
//# sourceMappingURL=CustomerBurnedBudgetHandle.js.map